import { useEffect, useState } from "react";

const STORAGE_KEY = "newsLastVisitTime";
const UPDATE_EVENT = "news-last-visit-update";

const read = (): number => {
  const raw = localStorage.getItem(STORAGE_KEY);
  const n = raw ? Number(raw) : 0;
  return Number.isFinite(n) ? n : 0;
};

export const markNewsVisited = (time: number = Date.now()) => {
  localStorage.setItem(STORAGE_KEY, String(time));
  window.dispatchEvent(new CustomEvent(UPDATE_EVENT));
};

export const useNewsLastVisit = (): number => {
  const [value, setValue] = useState<number>(read);
  useEffect(() => {
    const handler = () => setValue(read());
    window.addEventListener(UPDATE_EVENT, handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener(UPDATE_EVENT, handler);
      window.removeEventListener("storage", handler);
    };
  }, []);
  return value;
};
